/**
 * Colours the phone's status bar and browser bars for a full-screen view (camera, voice mode)
 * and returns how to put the previous colour back. The theme-color meta is replaced, not
 * edited: iOS re-reads the colour when the element is inserted, not when its content changes.
 */
export function setStatusBarColor(color: string): () => void {
  const replace = (value: string) => {
    for (const meta of document.querySelectorAll('meta[name="theme-color"]')) meta.remove();
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = value;
    document.head.append(meta);
  };
  const previous =
    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.content ?? null;
  replace(color);
  return () => {
    if (previous !== null) replace(previous);
    else for (const meta of document.querySelectorAll('meta[name="theme-color"]')) meta.remove();
  };
}
